import React, { Component } from 'react';
//import { Button } from 'reactstrap';
//import { bindActionCreators } from 'redux';
//import { connect } from 'react-redux';
import { platformHandler } from '../platforms/PlatformHandler'

//import { setSelectedPPT } from '../App/actions';
//
import CircularProgress from '@material-ui/core/CircularProgress';

class Initial extends Component {

	componentDidMount(){
		platformHandler.checkTitleBarScene("Initial",true);	
		platformHandler.setHistory( this.props.history);
	}

	render() {
    	return (
			<React.Fragment>
		        <CircularProgress size={50} />
			</React.Fragment>
	    );
	}
}

/*const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ setSelectedPPT }, dispatch),
});

export default connect(null, mapDispatchToProps)(Initial);*/
export default Initial;



// WEBPACK FOOTER //
// ./src/containers/scenes/Initial.js